import { Link, useParams } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import { getNewsById } from '@/utils/media';

export default function NewsDetail() {
  const { id } = useParams<{ id: string }>();
  const news = id ? getNewsById(id) : undefined;

  if (!news) {
    return (
      <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
          <i className="ri-newspaper-line text-3xl"></i>
        </span>
        <h1 className="mt-4 text-xl font-bold text-foreground-800">没有找到该资讯</h1>
        <p className="mt-1 text-sm text-foreground-500">文章可能已被移除，去看看其他资讯吧</p>
        <Link
          to="/news"
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const others = newsList.filter((n) => n.id !== news.id).slice(0, 4);

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6">
      <nav className="mb-4 flex flex-wrap items-center gap-2 text-sm text-foreground-500">
        <Link to="/" className="hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line"></i>
        <Link to="/news" className="hover:text-primary-600">影视资讯</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">正文</span>
      </nav>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <article className="lg:col-span-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-secondary-900">
                <i className="ri-price-tag-3-line"></i> {news.source}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i> {news.date}
              </span>
            </div>
            <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {news.title}
            </h1>
            <p className="mt-4 rounded-md border-l-4 border-primary-300 bg-primary-50 p-4 text-sm leading-relaxed text-foreground-700">
              {news.summary}
            </p>
            <div className="mt-6 flex flex-col gap-4 text-sm leading-loose text-foreground-700">
              {news.content.split('。').filter(Boolean).map((sentence, idx) => (
                <p key={idx}>{sentence}。</p>
              ))}
            </div>

            <div className="mt-8 rounded-md bg-background-100 p-4 text-xs text-foreground-500">
              本文为演示内容，所有资讯均为虚构示例，仅用于展示页面效果。
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <span className="text-sm text-foreground-500">分享到：</span>
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-link', label: '复制链接' },
              ].map((s) => (
                <span
                  key={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-600"
                  title={`${s.label}（演示）`}
                >
                  <i className={s.icon}></i>
                </span>
              ))}
            </div>
          </div>
        </article>

        <aside className="flex flex-col gap-6">
          <section className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-newspaper-line text-primary-500"></i> 相关阅读
            </h2>
            <ul className="flex flex-col divide-y divide-background-200">
              {others.map((n) => (
                <li key={n.id}>
                  <Link to={`/news/${n.id}`} className="group block py-3">
                    <h3 className="line-clamp-2 text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                      {n.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-400">{n.date}</p>
                  </Link>
                </li>
              ))}
            </ul>
          </section>

          <Link
            to="/news"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-primary-300 bg-primary-50 py-3 text-sm font-medium text-primary-700 hover:bg-primary-100"
          >
            <i className="ri-arrow-left-line"></i> 返回资讯列表
          </Link>
        </aside>
      </div>
    </div>
  );
}